
import { APIRepository } from "~/context/Shared/infrastructure/APIRepository";
import { vectiAppApiUrl } from "~/context/Shared/infrastructure/Config";
import { AutoreconciliationDataRepository } from "../domain/AutoreconciliationDataRepository";
import { AutoreconciliationData } from "../domain/AutoreconciliationData";
import { AutoreconciliationSumByYearMonth } from "../domain/AutoreconciliationDataResumen";

export function createApiAutoreconciliationDataRepository(): AutoreconciliationDataRepository {
  return new APIAutoreconciliationDataRepository();
}

export class APIAutoreconciliationDataRepository extends APIRepository implements AutoreconciliationDataRepository {
  constructor() {
    super(vectiAppApiUrl());
  }

  getPendingAutoreconciliationDataByCompany(companyUid: string): Promise<AutoreconciliationData[]|any> {
    //console.log("getPendingReconciliationDataByCompany companyUid: " + companyUid);
    return this.doGet<AutoreconciliationData[]>("/api/autoreconciliations/company/" + companyUid.toString() + "/pending");
  }

  getResumePendingAutoreconciliationDataByCompany(companyUid: string): Promise<AutoreconciliationSumByYearMonth[]>{
    return this.doGet<AutoreconciliationSumByYearMonth[]>("/api/autoreconciliations/company/" + companyUid.toString() + "/pending/resume");
  }


}